module.exports = __webpack_public_path__ + "img/page_no_permission.ab16814a.png";